import { TotalStatisticResponse } from "@/api/generated-sources/flexsalary";
import { TotalStatisticResponseModel } from "../models/StatisticModel";

export function mapTotalStatisticResponseModel(
  dto?: TotalStatisticResponse,
): TotalStatisticResponseModel {
  return {
    numberOfEmployees: dto?.numberOfEmployees,
    percentAdvanceRequestAmount: dto?.percentAdvanceRequestAmount,
    percentTotalPaidAmount: dto?.percentTotalPaidAmount,
    totalAdvanceRequestAmount: dto?.totalAdvanceRequestAmount,
    totalPaidAmount: dto?.totalPaidAmount,
  };
}
